module.exports = "/images/vendor/desiigner-svg/svg/places/maya.svg?4bdcecd049a0e10e2e98567346cafa01";